import Vue from 'vue'
import VueRouter from 'vue-router'
import tools from '@/utils/tools'
import { PVUV } from '@/utils/pvuv'

Vue.use(VueRouter)
// 解决路由在 push/replace 了相同地址报错的问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace (location) {
  return originalReplace.call(this, location).catch(err => err)
}

const routes = []
// eslint-disable-next-line camelcase
const require_module = require.context('./modules', false, /.js$/)
require_module.keys().forEach((fileName) => {
  routes.push(require_module(fileName).default)
})

const router = new VueRouter({
  routes: routes.flat(),
  mode: 'hash'
  // base: '/web/questionnaire'
})
router.afterEach((to, from, next) => {
  if (tools.authorization()) {
    PVUV.setPVUV(to.path)
  }
})
// 白名单
const routesWhiteList = ['/login', '/register', '/forget']
router.beforeEach(async (to, from, next) => {
  if (tools.authorization()) {
    next()
    // if (to.path === '/login' || to.path === '/') {
    //   next({ path: '/Usercenter' })
    // } else {
    //   next()
    // }
  } else {
    if (routesWhiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next(`/login?redirect=${to.query.redirect || ''}`)
    }
  }
})
export default router
